<script setup lang="ts">
import { RouterView } from 'vue-router'

import { useOrdersStore } from './stores/orders'
import { onMounted } from 'vue'
import { usePusher } from '@/composables/usePusher'
import { toast } from 'vue3-toastify'

const pusher = usePusher()

onMounted(() => {
  const ordersStore = useOrdersStore()
  if (pusher != null) {
    // Orders channel
    const ordersChannel = pusher.subscribe('table-orders')
    ordersChannel.bind('new-order', async (data: any) => {
      // Wait a bit for WooCommerce to finish processing all hooks
      // (e.g., _order_creator_name is added after initial save)
      await new Promise((resolve) => setTimeout(resolve, 2000))

      // Fetch the complete order from API to get full data
      // This also handles deduplication - if order exists, it updates it
      const { success, isNew, order } = await ordersStore.fetchAndUpsertOrder(data.id)

      // Only show toast if this is a genuinely new order (not already added by createTable)
      if (success && isNew && order) {
        const tablenumMeta = order.meta_data?.find((meta: any) => meta.key === 'tablenum')
        const tableNumber = tablenumMeta ? tablenumMeta.value : 'غير معروف'
        toast.success(`تم اضافة طلب جديد - طاولة رقم ${tableNumber}`)
      }
    })

    // Notifications channel
    const notificationChannel = pusher.subscribe('noti')

    notificationChannel.bind('newnot', (data: any) => {
      const table = data.tablenum
      toast.success(`طاولة رقم ${table} طلبت المساعدة`)
    })

    notificationChannel.bind('newtable', (data: any) => {
      const table = data.tablenum
      if (table != '999999') {
        toast.success(`طاولة رقم ${table} قامت بمسح الرمز`)
      }
    })
  }
})
</script>
<template>
  <RouterView />
</template>
